import { render, staticRenderFns } from "./MallList.vue?vue&type=template&id=7f809f44&scoped=true"
import script from "./MallList.vue?vue&type=script&lang=js"
export * from "./MallList.vue?vue&type=script&lang=js"
import style0 from "./MallList.vue?vue&type=style&index=0&id=7f809f44&prod&scoped=true&lang=css"
import style1 from "./MallList.vue?vue&type=style&index=1&id=7f809f44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f809f44",
  null
  
)

export default component.exports